module.exports = __webpack_public_path__ + "img/nutrilon-lactose-free.4fdbf32e.png";